export default function mapObject(object, mapper) {
  return Object.keys(object).reduce(function (result, key) {
    result[key] = mapper(object[key], key);
    return result;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/radium/es/map-object.js
// module id = 178
// module chunks = 0